var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemediation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319712"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.904 6.4498C17.95 6.40168 18.0249 6.46087 17.9918 6.51935L11.5319 17.9713C11.5106 18.0091 11.4579 18.0095 11.4359 17.9722L6.89131 10.2433C6.86062 10.1912 6.91924 10.132 6.96907 10.1648L11.4466 13.1188C11.4688 13.1334 11.4978 13.1301 11.5164 13.1108L17.904 6.4498Z",
    fill: "#ACBED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.63043 0.0537073C9.22142 -0.270198 12.4549 0.863725 13.6509 3.6527L14.1439 2.64374L15.4201 3.30861L13.578 7.07826L10.0022 5.09952L10.6461 3.78181L11.7608 4.36258C10.9722 2.75549 8.88156 1.85369 6.87096 2.10504C5.88382 2.22845 4.90511 2.74767 4.14792 3.47055C3.37893 4.20474 2.94413 5.04426 2.87743 5.71605L0.886719 5.50533C1.01815 4.18157 1.7883 2.90912 2.78939 1.95337C3.80229 0.986334 5.15882 0.237678 6.63043 0.0537073Z",
    fill: "#ACBED2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M6.81508 12.4202C6.24985 12.296 5.69611 12.0686 5.19776 11.7632C4.42421 11.2893 3.87601 10.6861 3.60914 10.1182L4.7456 10.6394L5.32587 9.29057L1.66001 7.49609L0 11.3548L1.30631 11.954L1.75697 10.9064C2.22766 11.9868 3.13874 12.9043 4.17652 13.5402C5.30994 14.2347 6.73333 14.7577 8.1455 14.6828L6.81508 12.4202Z",
    fill: "#ACBED2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemediation);
export default __webpack_public_path__ + "static/media/Remediation.21ab62440576eeb6cd3e4939133dd540.svg";
export { ForwardRef as ReactComponent };